// Offer prices: the marketing price (marketing_price) is the per-person price used
// for marketing, the website price (website_price, its own field) the price shown
// on the customer's own website. Admin2 applies the same plausibility rule when it
// takes prices over from CMS2 (Cms2::Offers::Sync).
export const PRICE_PER_PERSON = 'pro Person'

// Descriptions that already mean the price of one person ("Gesamtpreis (EZ)" is the
// package for one person in a single room). Mirrors Platform::Offers::PriceReport.
const PER_PERSON = /pro\s*(Person|Pers\.|Teilnehmer)|\bp\.\s*P\.|\bEZ\b|\b1\s*Pers|Einzel/i

export function isPerPersonDescription(description) {
  return PER_PERSON.test(String(description || ''))
}

function euroToCents(value) {
  if (value === null || value === undefined || String(value).trim() === '') return null
  const number = Number(String(value).replace(',', '.'))
  return Number.isFinite(number) && number > 0 ? Math.round(number * 100) : null
}

function formatEuro(cents) {
  return `${(cents / 100).toFixed(2).replace('.', ',')} €`
}

// One person pays between half (double room) and all of a total price. Only a
// total ("Gesamtpreis …") can be checked; "pro Nacht" and similar are left alone.
export function pricePairWarning(perPerson, websitePrice, websiteDescription) {
  const perPersonCents = euroToCents(perPerson)
  const totalCents = euroToCents(websitePrice)
  // "Gesamtpreis (1 Pers. im DZ)" is per person: two per-person prices are not compared.
  const isTotal = /gesamt/i.test(String(websiteDescription || '')) && !isPerPersonDescription(websiteDescription)
  if (totalCents === null || !isTotal) return null
  if (perPersonCents === null) {
    return 'Bitte hinterlegen Sie für die Vermarktung auch einen Preis pro Person.'
  }
  if (perPersonCents * 2 < totalCents || perPersonCents > totalCents) {
    return `Der Preis pro Person (${formatEuro(perPersonCents)}) passt nicht zum Gesamtpreis ` +
      `(${formatEuro(totalCents)}). Erwartet wird ein Wert zwischen der Hälfte und dem vollen Gesamtpreis.`
  }
  return null
}

export function websiteHosts(websites) {
  const hosts = (websites || []).map((website) => {
    try {
      return new URL(website.url).host
    } catch {
      return null
    }
  }).filter(Boolean)
  return [...new Set(hosts)]
}
